"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ScrollView = _interopRequireDefault(require("react-native-web/dist/cjs/exports/ScrollView"));
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DEBOUNCE_MS = 100;

/**
 * A wrapper for ScrollView that supports an `onScrollEnd` function.
 *
 * React Native Web hasn't got around to implementing any scroll end handlers yet,
 * so we need to work around it with debouncing on `onScroll`. See:
 * https://github.com/necolas/react-native-web/issues/1021
 */
const ScrollViewEnd = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    onScrollEnd,
    onScroll = null,
    ...props
  } = _ref;
  // Return debounced function directly from useCallback so it has .cancel method etc.
  // Linter complains this stops it automatically scanning the deps, but we can check them manually.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceScrollEnd = _react.default.useCallback((0, _lodash.default)(event => onScrollEnd(event), DEBOUNCE_MS), [onScrollEnd]);

  // Call any onScroll handler immediately, and any onScrollEnd handler after 100ms of no scrolling
  const handleScroll = event => {
    if (typeof onScroll === 'function') onScroll(event);
    if (typeof onScrollEnd === 'function') debounceScrollEnd(event);
  };

  // Cancel any lingering debounce timeouts on dismount
  _react.default.useEffect(() => debounceScrollEnd.cancel);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScrollView.default, {
    ref: ref,
    ...props,
    onScroll: handleScroll,
    scrollEventThrottle: DEBOUNCE_MS / 2
  });
});
ScrollViewEnd.displayName = 'ScrollViewEnd';
ScrollViewEnd.propTypes = {
  onScrollEnd: _propTypes.default.func.isRequired,
  onScroll: _propTypes.default.func
};
var _default = exports.default = ScrollViewEnd;